import React, {useState} from 'react';
import type { NextPage } from 'next'
import Head from 'next/head'
import {InputText} from "primereact/inputtext";
import {Button} from "primereact/button";
import Image from "next/image";

// Form Data
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { pt } from 'yup-locale-pt';
import FieldMessage from "../../../components/FieldMessage/FieldMessage";
import {classNames} from "primereact/utils";
import {Dropdown} from "primereact/dropdown";
import {recoveryPassword} from "../../../services/authService";
import {Message} from "primereact/message";
import Link from "next/link";

yup.setLocale(pt);

const schema = yup.object({
    email: yup.string().email().required().label('E-mail'),
    type: yup.string().required().label('Tipo do Acesso'),
}).required();

const defaultValues = {
    email: '',
    type: '',
}

const accessOption = [
    {label: 'Chefe do Programa', value: 'boss'},
    {label: 'Fellow', value: 'resident'},
];

const RecoveryPassword: NextPage = () => {

    const [loading, setLoading] = useState(false);
    const [statusMessage, setStatusMessage] = useState<'success' | 'info' | 'warn' | 'error' | undefined>(undefined);
    const [message, setMessage] = useState("");

    const { control, formState: { errors }, handleSubmit } = useForm({
        defaultValues:defaultValues,
        resolver: yupResolver(schema)
    });

    const onClearMessages = async() => {
        setMessage("");
        setStatusMessage(undefined)
    }

    const onSubmit = async (data:any) => {
        try{

            onClearMessages();
            setLoading(true);

            await recoveryPassword(data);

            setStatusMessage("success");
            setMessage('Sua solicitação para recuperação de senha foi realizada com sucesso. Verifique seu e-mail para mais informações.');

            setLoading(false);

        }catch(error : any){

            if(error.response)
                setMessage(error.response.data.message);
            else
                setMessage(error.message);

            setStatusMessage("error");
            setLoading(false);

        }
    }

    return (
        <div>
            <Head>
                <title>Recupear Senha - Plataforma de Serviços Formadores Credenciados</title>
            </Head>
            <main>
                <div className="min-h-screen flex">
                    <div className="surface-section w-full md:w-6 p-6 md:p-8">
                        <div className="mb-5">
                            <Image
                                src="/logo-customer.png"
                                alt="logo-customer"
                                width={200}
                                height={80}
                                className="mb-3 fadein animation-duration-1000"/>
                            <h3
                                className="text-3xl font-medium mb-3 fadein animation-duration-1000"
                                style={{color: "#293988"}}
                            >
                                Esqueceu sua senha ?
                            </h3>
                            <p className="font-light mr-2 fadein animation-duration-1000" style={{color: "#293988"}}>
                                Digite seu endereço de e-mail associado à sua conta e enviaremos uma nova senha.
                            </p>
                        </div>
                        <form onSubmit={handleSubmit(onSubmit)} className="fadein animation-duration-1000">

                            { message && <Message severity={statusMessage} text={message} className="mb-5" style={{width: '100%'}} />}

                            <label htmlFor="email" className="block text-900 font-medium mb-2">E-mail:</label>
                            <span className="p-input-icon-left mb-2" style={{display: 'flex'}}>
                                <i className="pi pi-envelope"/>
                                <Controller name="email" control={control} render={({field, fieldState}) => (
                                    <>
                                        <InputText
                                            placeholder="Insira seu e-mail"
                                            type="email" id={field.name}
                                            {...field}
                                            autoFocus
                                            className={classNames({'p-invalid': fieldState.invalid}, 'w-full')}
                                        />
                                    </>
                                )}/>
                            </span>
                            <FieldMessage name="email" error={errors.email}/>

                            <label htmlFor="password" className="block text-900 font-medium mt-3 mb-2">Tipo de Acesso:</label>
                            <span className="p-input-icon-left mb-2" style={{width: '100%'}}>
                                <i className="pi pi-lock"/>
                                <Controller name="type" control={control} render={({field, fieldState}) => (
                                    <Dropdown
                                        options={accessOption}
                                        placeholder="Escolha uma opção:"
                                        id={field.name}
                                        {...field}
                                        style={{width: '100%'}}
                                        className={classNames({ 'p-invalid': fieldState.invalid }, )}
                                    />
                                )}/>
                            </span>
                            <FieldMessage name="password" error={errors.type}/>

                            <Button type="submit" label="Recuperar Senha" loading={loading} icon="pi pi-check-circle"
                                    className="w-full py-3 mt-3 mb-5"/>

                            <div className="w-full text-center font-medium">
                            <Link
                                href={"/"}
                                style={{color: '#29378b'}}
                                className="w-full text-center font-medium underline text-center cursor-pointer">
                                Voltar para o login</Link>
                            </div>
                        </form>
                    </div>
                    <div className="hidden md:block w-6 bg-no-repeat bg-cover fadein animation-duration-1000"
                         style={{
                             backgroundImage: "url('/recovery-password-image.png')",
                             backgroundPosition: "left"
                         }}>
                    </div>
                </div>
            </main>
        </div>
    )
}

export default RecoveryPassword
